import { IApplicationState } from '../../types/redux';
import { getInfrastructureFromBuilder, getTransportAccessibility } from '../newbuilding';

export const getIsTransportAccessibilityServiceAvailable = (state: IApplicationState) => {
  const transportAccessibility = getTransportAccessibility(state);
  const infrastructureFromBuilder = getInfrastructureFromBuilder(state);

  return Boolean(transportAccessibility || infrastructureFromBuilder);
};
